import { useState } from 'react';

/**
 * Toast state shared by every Supporting Tools screen.
 *
 * `showToast(severity, summary, detail, sticky)` — a sticky toast (the outcome of a
 * save/delete) stays until the user dismisses it; any other toast clears itself
 * after four seconds. `setToast(null)` dismisses one by hand. Render the result
 * with <Toast toast={toast} onClose={() => setToast(null)} />.
 */
export function useToast() {
  const [toast, setToast] = useState(null);

  const showToast = (severity, summary, detail, sticky = false) => {
    setToast({ severity, summary, detail, sticky });
    if (!sticky) setTimeout(() => setToast(null), 4000);
  };

  return { toast, setToast, showToast };
}
